import { config } from 'settings/custom/tweens'
import { log } from 'utils/Logger'

let storage = null

function init() {
  storage = config
}

function getTween(key) {

  if( storage.hasOwnProperty(key)){

    return storage[key]
  }
  else {
    log(`Cant find key ${key} in text config`)
  }

}

export const TextTweenService = { init, getTween }
